interface AvailabilityStatus {
  text: string;
  className: string;
  isAvailable: boolean;
  reason: string;
}

interface DesktopProductActionsProps {
  availabilityStatus: AvailabilityStatus;
  isAddingToCart: boolean;
  onAddToCart: () => void;
  onOrderNow: () => void;
}

export function DesktopProductActions({ 
  availabilityStatus, 
  isAddingToCart, 
  onAddToCart, 
  onOrderNow 
}: DesktopProductActionsProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Add to Cart Button */}
      <button
        onClick={onAddToCart}
        disabled={!availabilityStatus.isAvailable || isAddingToCart}
        className={`
          py-4 px-6 border-2 rounded-xl text-xl font-bold transition-colors
          ${!availabilityStatus.isAvailable
            ? 'border-gray-300 text-gray-500 bg-gray-100 cursor-not-allowed'
            : 'border-green-500 text-green-500 hover:bg-green-50 active:bg-green-100'
          }
        `}
      >
        {!availabilityStatus.isAvailable 
          ? availabilityStatus.text 
          : isAddingToCart ? '담는 중...' : '장바구니'
        }
      </button>

      {/* Order Now Button */}
      <button
        onClick={onOrderNow}
        disabled={!availabilityStatus.isAvailable}
        className={`
          py-4 px-6 rounded-xl text-xl font-bold transition-colors
          ${!availabilityStatus.isAvailable
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
            : 'bg-green-500 text-white hover:bg-green-600 active:bg-green-700'
          }
        `}
      >
        {!availabilityStatus.isAvailable 
          ? availabilityStatus.text 
          : '바로 주문'
        }
      </button>
    </div>
  );
}